import { api } from "./api";

export const createHrUser = async ({
  name,
  phone,
  privilege,
  password,
  companyId,
}: any) => {
  try {
    const res = await api.post(`/hr-user`, {
      name,
      phone,
      privilege,
      password,
      companyId,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getHrUsersList = async ({
  pageNumber,
  limit,
  companyId,
  sort,
  privilege,
  name,
}: {
  pageNumber?: number;
  limit?: number;
  companyId: string;
  sort?: string;
  privilege?: string;
  name?: string;
}) => {
  try {
    const params: Record<string, any> = {};
    if (pageNumber !== undefined) params.pageNumber = pageNumber;
    if (limit !== undefined) params.limit = limit;
    if (companyId !== undefined) params.companyId = companyId;
    if (sort !== undefined) params.sort = sort;
    if (privilege !== undefined) params.privilege = privilege;
    if (name !== undefined) params.name = name;

    const res = await api.get(`/hr-user/list`, { params });
    return res;
  } catch (error) {
    return error;
  }
};

export const getHrUsersById = async ({ id }: any) => {
  try {
    const res = await api.get(`/hr-user?_id=${id}`);
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteHrUserById = async ({ id }: any) => {
  try {
    const res = await api.delete(`/hr-user`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateHrUserById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`/hr-user`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};
